import { render, staticRenderFns } from "./WorkDays.vue?vue&type=template&id=174f25b2&scoped=true&"
import script from "./WorkDays.vue?vue&type=script&lang=js&"
export * from "./WorkDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174f25b2",
  null
  
)

export default component.exports